import { Link, useLocation } from 'react-router'
import { AspectRatio, Image, Text } from '@mantine/core'
import { useMediaQuery } from '@mantine/hooks'
import { FeaturedNews } from './api'
import NewsPlaceholder from '../assets/news_placeholder.png'
import classes from './News.module.css'
import { Typography } from '../common/typography'

export default function FeaturedNewsComponent({
  news,
}: {
  news: FeaturedNews
}) {
  const isDesktop = useMediaQuery('(min-width: 1200px)')
  const location = useLocation()

  if (isDesktop) {
    return (
      <div className={classes.featuredNews}>
        <Typography
          level={2}
          fw={500}
          lh="125"
          fc={{ light: 'black', dark: 'gray-3' }}
        >
          Featured News
        </Typography>

        <div className={classes.featuredNewsContainer}>
          <Link
            className={classes.newsCardLink}
            to={`/news/${news.news_id}`}
            state={{ from: location }}
          >
            <AspectRatio ratio={16 / 9} className={classes.news_image}>
              <Image
                className={classes.news_image}
                src={news.image.main || NewsPlaceholder}
                alt={news.title}
              />
            </AspectRatio>
          </Link>
          <div className={classes.featuredNewsCard}>
            <div className={classes.featuredNewsDescription}>
              <Link
                className={classes.newsCardLink}
                to={`/news/${news.news_id}`}
                state={{ from: location }}
              >
                <Typography level={2} fw={700} fs="xxl" lh="100">
                  {news.title}
                </Typography>
              </Link>
              <Typography
                fs="xs"
                fc={{ light: 'gray-5', dark: 'gray-5' }}
                lh="150"
              >
                {new Date(news.created_at).toLocaleString('en-GB', {
                  day: '2-digit',
                  month: '2-digit',
                  year: 'numeric',
                  hour: '2-digit',
                  minute: '2-digit',
                  hour12: false,
                })}
              </Typography>
            </div>

            <div className={classes.featuredNewsSummary}>
              <Typography lh="150" className={classes.summary}>
                {news.summary}
              </Typography>
              <Link to={`/news/${news.news_id}`} state={{ from: location }}>
                <Typography
                  fc={{ light: 'primary-5', dark: 'primary-3' }}
                  lh="150"
                  className={classes.newsLink}
                >
                  Read More
                </Typography>
              </Link>
            </div>
          </div>
          <div className={classes.newsDetails} />
        </div>
      </div>
    )
  }

  return (
    <Link
      className={classes.newsCardLink}
      to={`/news/${news.news_id}`}
      state={{ from: location }}
    >
      <div className={classes.featuredNews}>
        <Typography
          level={2}
          fs="xl"
          fw={500}
          lh="125"
          fc={{ light: 'black', dark: 'gray-2' }}
        >
          Featured News
        </Typography>

        <div className={classes.featuredNewsContainer}>
          <AspectRatio ratio={16 / 9} className={classes.news_image}>
            <Image
              src={news.image.main || NewsPlaceholder}
              alt={news.title}
              className={classes.news_image}
            />
          </AspectRatio>
          <div className={classes.featuredNewsCard}>
            <Typography level={2} fw={700} fs="xxl" lh="100">
              {news.title}
            </Typography>
            <div className={classes.featuredNewsSummary}>
              <Text component="p">{news.summary}</Text>
              <Typography
                fc={{ light: 'primary-5', dark: 'primary-3' }}
                lh="150"
                className={classes.newsLink}
              >
                Read More
              </Typography>
            </div>
            <Typography
              fs="xs"
              fc={{ light: 'gray-5', dark: 'gray-3' }}
              lh="150"
            >
              {new Date(news.created_at).toLocaleString('en-GB', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
                hour12: false,
              })}
            </Typography>
          </div>
          <div className={classes.newsDetails} />
        </div>
      </div>
    </Link>
  )
}
